export const getConfig = (): AppConfig => {
  return (
    window.config || {
      gateway: {
        url: process.env.REACT_APP_GATEWAY_URL || "http://localhost:4000/graphql",
      },
      application: {
        name: "Nova 4.0",
        version: "latest",
      },
      muiXProLicense: process.env.REACT_APP_MUIX_PRO_LICENSE || "",
      environment: "local",
      webService: {
        url: process.env.NOVA_API_URL_PUBLIC || "http://localhost:8080",
        apiKeyInternal: process.env.API_KEY_INTERNAL || "1",
      },
    }
  );
};
